import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MainLayout } from 'layouts/MainLayout';
import { segmentsApi } from 'components/audience/segmentsApi';
import { MARKETING_AUDIENCES } from 'config/routes';
import logger from 'lib/logger';
import { isString } from 'lib/typeguards';
import { Throbber } from 'ui/Throbber';
import { AudienceView } from 'components/audience/SegmentView';

export const MarketingAudiencesView = () => {
    const [segment, setSegment] = React.useState(null);
    const navigate = useNavigate();
    const { audienceId: segmentId } = useParams<{ audienceId: string }>();

    React.useEffect(() => {
        async function load() {
            try {
                if (!isString(segmentId)) {
                    logger.error(`Expected segmentId but got ${segmentId}`);
                    navigate(MARKETING_AUDIENCES);
                }
                const segmentResponse = await segmentsApi.get(segmentId);
                if (!segmentResponse.ok) {
                    logger.error('Expected segmentResponse 200 but got ', segmentResponse);
                    navigate(MARKETING_AUDIENCES);
                }
                setSegment(segmentResponse.body);
            } catch (error) {
                logger.error('Audience view page error', error);
                navigate(MARKETING_AUDIENCES);
            }
        }
        load();
    }, [navigate, segmentId]);

    if (!segment) {
        return (
            <MainLayout
                breadcrumbs={[{ label: 'Audiences', url: MARKETING_AUDIENCES }]}
                pageName={'Audience Details'}
                pageDescription="View more information on your audience"
            >
                <Throbber />
            </MainLayout>
        );
    }

    return (
        <MainLayout
            breadcrumbs={[{ label: 'Audiences', url: MARKETING_AUDIENCES }]}
            pageName={segment.title || 'Audience Details'}
            pageDescription="View more information on your audience"
        >
            <AudienceView segment={segment} />
        </MainLayout>
    );
};
